module.exports = __webpack_public_path__ + "static/media/2 4 Ordkjedetest-Feil-ost-par-vask-jakt.44f3efad.mp3";